import React from 'react';
import styled from 'styled-components';
import { ProgressContainer } from 'app/components/tv/customControls/ProgressContainer';
import { ExitPlayerButton } from 'app/components/tv/customControls/ExitPlayerButton';
import { MatchScoreOverlay } from 'app/components/tv/customControls/MatchScoreOverlay';
const Wrapper = styled.div.withConfig({
  componentId: "sc-1rgwbyo-0"
})(["position:fixed;top:0;left:0;width:", ";z-index:9999;display:flex;flex-direction:column;"], props => props.adPlaying ? 'auto' : '100%');
const FlexContainer = styled.div.withConfig({
  componentId: "sc-1rgwbyo-1"
})(["display:flex;align-items:center;"]);
export const HeaderBar = _ref => {
  let {
    adPlaying,
    playlistOpen,
    playerRef,
    playerReady,
    playlist,
    video,
    hideAll,
    onExitPlayer,
    currentVideoIndex
  } = _ref;
  if (playlistOpen || hideAll) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Wrapper, {
    adPlaying: adPlaying,
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "HeaderBar",
    "data-sentry-source-file": "HeaderBar.tsx"
  }, /*#__PURE__*/React.createElement(ProgressContainer, {
    video: video,
    show: !adPlaying && !playlistOpen,
    playerRef: playerRef,
    playerReady: playerReady,
    playlist: playlist,
    currentVideoIndex: currentVideoIndex,
    "data-sentry-element": "ProgressContainer",
    "data-sentry-source-file": "HeaderBar.tsx"
  }), /*#__PURE__*/React.createElement(FlexContainer, {
    "data-sentry-element": "FlexContainer",
    "data-sentry-source-file": "HeaderBar.tsx"
  }, /*#__PURE__*/React.createElement(ExitPlayerButton, {
    onExitPlayer: onExitPlayer,
    "data-sentry-element": "ExitPlayerButton",
    "data-sentry-source-file": "HeaderBar.tsx"
  }), /*#__PURE__*/React.createElement(MatchScoreOverlay, {
    show: !adPlaying && !playlistOpen,
    video: video,
    "data-sentry-element": "MatchScoreOverlay",
    "data-sentry-source-file": "HeaderBar.tsx"
  })));
};